import React, { Component } from 'react'
import OptionsDialog from './OptionsDialog'
import { Button } from '@mui/material';

export class YesNoDialog extends Component {
    render() {
        const { open, onClose, title, label } = this.props;
        return (
            <OptionsDialog
                open={open}
                onClose={onClose}
                title={title}
                label={label}
                actions={
                    <>
                        <Button variant="contained" color="primary" onClick={() => onClose(true)}>
                            Ja
                        </Button>
                        <Button variant="outlined" color="primary" onClick={() => onClose(false)}>
                            Nein
                        </Button>
                    </>
                }
            />
        )
    }
}

export default YesNoDialog